import { vars } from "@imwebme/clay-token";
import type { PropsWithChildren, Ref } from "react";
import { forwardRef } from "react";
import { Clay } from "../../utilities";

export const VisualModalBody = forwardRef((props: PropsWithChildren, ref: Ref<HTMLDivElement>) => {
  return (
    <Clay ref={ref} textAlign="center" paddingLeft={vars.spacing[6]} paddingRight={vars.spacing[6]}>
      {props.children}
    </Clay>
  );
});

VisualModalBody.displayName = "VisualModalBody";
